import classNames from "classnames";
import * as React from "react";
import { Input, Label } from "uxp/components";
import { hasValue } from "../../../../util";
import { IBaseFieldProperty, IBaseInputFieldProperty, IPropertyEditorProps, IUIFieldProps, IUIPropertyDefinition, registerUIField } from "../../common";
import { FieldProperty, FieldTitle, IFieldTitleProps } from "../../components/FieldTitle";
import { CustomColorPicker, escapeUnit, Property, PropertyContainer, PropertyGroup, PropertyGroupTitle, PropertyTitle, TextAlignEditor } from "../../ui-props/common";
import { CustomUI, CustomUIPropertyEditor, ICustomUIDefinition, ICustomUIFieldProperty } from "../../custom-ui/CustomUI";



export const Field: React.FunctionComponent<IUIFieldProps<ICustomUIFieldProperty>> = (props) => {


	return (
		<div className={classNames('ui-field-custom-ui ui-field', props.mode)} >
			<FieldTitle {...props?.fieldProps?.fieldLabel || {}} />
			<CustomUI mode={props?.designer?.mode} mobile={props?.fieldProps?.mobile} web={props?.fieldProps?.web} />
		</div >
	)
}


registerUIField({
	id: 'custom-ui',
	category: 'actions-advanced',
	description: 'Custom Interface ',
	field: Field,
	isInputField: true,
	propertyEditor: CustomUIPropertyEditor,
	defaultProps: {
		web:'',
        mobile:'',
		binding:null,
		fieldLabel: {
			label: '',
		},
	},
	type:'position'

});


